import { render, staticRenderFns } from "./FieldModalCallBellNfcs.vue?vue&type=template&id=44f4c52c&scoped=true&"
import script from "./FieldModalCallBellNfcs.vue?vue&type=script&lang=js&"
export * from "./FieldModalCallBellNfcs.vue?vue&type=script&lang=js&"
import style0 from "./FieldModalCallBellNfcs.vue?vue&type=style&index=0&id=44f4c52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4c52c",
  null
  
)

export default component.exports